import { Base64 } from "js-base64";

const blacklistedChars = "\\!@#$%^&*()+=-[]';,./{}|\":<>?~`";

export function transformPTLsToURL(ptls = {}, encodePTL = true) {
  const isPTLsEmpty = !ptls || Object.keys(ptls).length === 0;
  if (isPTLsEmpty) {
    return "";
  }
  if (encodePTL) {
    return Base64.encode(JSON.stringify(ptls));
  }
  return Object.keys(ptls)
    .map((ptl) => `${ptl}=${ptls[ptl]}`)
    .join("&");
}

export function checkBlacklistedCharsInPTL(
  ptls = {},
  blacklistedCharacters = blacklistedChars
) {
  return Object.values(ptls).some((ptlAnswer = "") =>
    `${ptlAnswer}`
      .split("")
      .some((char) => blacklistedCharacters.includes(char))
  );
}

export function transformPTLsFromURL(encodedPTLs, queryString = "") {
  try {
    if (encodedPTLs) {
      const URIDecodedVal = decodeURIComponent(encodedPTLs);
      const decodedPTLs = Base64.decode(URIDecodedVal);
      let decodedVal = JSON.parse(decodedPTLs);
      if (
        Object.prototype.hasOwnProperty.call(decodedVal, "Campaign_ID") &&
        Object.prototype.hasOwnProperty.call(decodedVal, "PTL")
      ) {
        decodedVal = { ...decodedVal, ...decodedVal.PTL };
        delete decodedVal["Campaign_ID"];
        delete decodedVal["Customer_ID"];
        delete decodedVal["Wave_ID"];
        delete decodedVal["survey_id"];
        delete decodedVal["PTL"];
      }
      return decodedVal;
    }
    const ptls = {};
    const searchParams = new URLSearchParams(queryString);
    for (let [key, value] of searchParams) {
      ptls[key] = value;
    }
    return ptls;
  } catch (error) {
    window.console.error(error);
    return {};
  }
}

export function fetchCustomerDetailsFromURL(encodedVal, searchParams) {
  try {
    if (searchParams.get("Campaign_ID") && searchParams.get("Customer_ID")) {
      return {
        campaignID: searchParams.get("Campaign_ID") || "",
        customerID: searchParams.get("Customer_ID") || "",
        waveID: searchParams.get("Wave_ID") || "",
      };
    }
    if (encodedVal) {
      const URIDecodedVal = decodeURIComponent(encodedVal);
      const decodedVals = Base64.decode(URIDecodedVal);
      const obj = JSON.parse(decodedVals);
      if (obj.Campaign_ID && obj.Customer_ID) {
        return {
          campaignID: obj.Campaign_ID || "",
          customerID: obj.Customer_ID || "",
          waveID: obj.Wave_ID || "",
        };
      }
    }

    return null;
  } catch (error) {
    window.console.error(error);
    return {};
  }
}

export function fetchSurveyIdFromURL(encodedVal) {
  try {
    if (encodedVal) {
      const URIDecodedVal = decodeURIComponent(encodedVal);
      const decodedVals = Base64.decode(URIDecodedVal);
      const obj = JSON.parse(decodedVals);
      if (obj.survey_id) {
        return obj.survey_id;
      }
    }
    return null;
  } catch (error) {
    window.console.error(error);
    return "";
  }
}

export function isPTLinURLBroken(ptlQuestions = [], ptlAnswers = {}) {
  const ptlAnswersCopy = { ...ptlAnswers };

  // check if any required PTL is not there
  ptlQuestions.forEach((ptlQuestion) => {
    const answerKey =
      ptlQuestion.type === "hidden"
        ? ptlQuestion.jsonKey
        : ptlQuestion.questionLabel;
    if (ptlQuestion.required && !ptlAnswersCopy[answerKey]) {
      return true;
    }
    // if it has other question then delete both
    // deleting it to mark that it has been checked
    if (ptlQuestion.other) {
      delete ptlAnswersCopy[ptlQuestion.otherQuestionId];
    }
    delete ptlAnswersCopy[answerKey];
  });

  // check if anything is left in the ptlAnswers
  // if there is something that means URL is broken
  return Object.keys(ptlAnswersCopy).length !== 0;
}
